import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Phone, Mail } from 'lucide-react';

// --- FOOTER ---
const Footer = () => {
    const [email, setEmail] = useState('');
    const [subscribeStatus, setSubscribeStatus] = useState('');

    const scrollToSection = (sectionId) => {
        const section = document.getElementById(sectionId);
        if (section) {
            section.scrollIntoView({ behavior: 'smooth' });
        }
    };

    const handleSubscription = async (e) => {
        e.preventDefault();
        setSubscribeStatus('Sending...');

        try {
            const response = await fetch('https://smartsolutionslk.com/api/subscribe.php', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ email: email }),
            });
            
            const result = await response.json();

            if (response.ok) {
                setSubscribeStatus('Thank you for subscribing!');
                setEmail('');
            } else {
                throw new Error(result.message || 'Something went wrong.');
            }
        } catch (error) {
            setSubscribeStatus(error.message);
        }
    };

    return (
        <footer className="bg-black text-gray-400">
            <div className="container mx-auto px-6 pt-16 pb-8">
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
                    {/* Column 1: Logo & Socials - Centered on mobile, left-aligned on desktop */}
                    <div className="lg:col-span-1 flex flex-col items-center md:items-start">
                        <a href="#home" onClick={() => scrollToSection('home')} className="flex items-center gap-2">
                            <img
                                src="/logo_smweb.png"
                                alt="SmartSolutions Web Logo"
                                className="h-16 w-auto object-contain"
                                style={{ maxHeight: 64 }}
                            />
                        </a>
                        <p className="text-sm mt-2 text-center md:text-left">Engineering Digital Reality.</p>
                        <div className="flex space-x-4 mt-6">
                            <a href="https://www.linkedin.com/company/smartsolutionslk" className="text-gray-400 hover:text-white transition-colors transform hover:scale-110" aria-label="LinkedIn">
                                <svg role="img" width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 0 1-2.063-2.065 2.064 2.064 0 1 1 2.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.225 0z"/>
                                </svg>
                            </a>
                            <a href="https://www.facebook.com/SHSLHome" className="text-gray-400 hover:text-white transition-colors transform hover:scale-110" aria-label="Facebook">
                                <svg role="img" width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M22.675 0h-21.35C.595 0 0 .592 0 1.326v21.348C0 23.408.595 24 1.325 24h11.495v-9.294H9.692V11.01h3.128V8.413c0-3.1 1.893-4.788 4.659-4.788 1.325 0 2.463.099 2.797.143v3.24l-1.918.001c-1.504 0-1.797.715-1.797 1.763v2.313h3.587l-.467 3.696h-3.12V24h6.116C23.405 24 24 23.408 24 22.674V1.326C24 .592 23.405 0 22.675 0"/>
                                </svg>
                            </a>
                            <a href="https://www.instagram.com/smartsolutionslk?igsh=OHlmZ2tjbTNoaG8w" className="text-gray-400 hover:text-white transition-colors transform hover:scale-110" aria-label="Instagram">
                                <svg role="img" width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 1.366.062 2.633.334 3.608 1.308.974.974 1.246 2.241 1.308 3.608.058 1.266.07 1.646.07 4.85s-.012 3.584-.07 4.85c-.062 1.366-.334 2.633-1.308 3.608-.974.974-2.241 1.246-3.608 1.308-1.266.058-1.646.07-4.85.07s-3.584-.012-4.85-.07c-1.366-.062-2.633-.334-3.608-1.308-.974-.974-1.246-2.241-1.308-3.608C2.175 15.647 2.163 15.267 2.163 12s.012-3.584.07-4.85c.062-1.366.334 2.633 1.308-3.608.974-.974 2.241-1.246 3.608-1.308C8.416 2.175 8.796 2.163 12 2.163zm0-2.163C8.741 0 8.332.013 7.052.072 5.775.13 4.602.402 3.635 1.37c-.967.967-1.24 2.14-1.298 3.417C2.013 5.668 2 6.077 2 12c0 5.923.013 6.332.072 7.613.058 1.277.331 2.45 1.298 3.417.967.967 2.14 1.24 3.417 1.298C8.332 23.987 8.741 24 12 24s3.668-.013 4.948-.072c1.277-.058 2.45-.331 3.417-1.298.967-.967 1.24-2.14 1.298-3.417.059-1.281.072-1.69.072-7.613 0-5.923-.013-6.332-.072-7.613-.058-1.277-.331-2.45-1.298-3.417-.967-.967-2.14-1.24-3.417-1.298C15.668.013 15.259 0 12 0zm0 5.838a6.162 6.162 0 1 0 0 12.324 6.162 6.162 0 0 0 0-12.324zm0 10.162a3.999 3.999 0 1 1 0-7.998 3.999 3.999 0 0 1 0 7.998zm7.2-10.406a1.44 1.44 0 1 0 0 2.88 1.44 1.44 0 0 0 0-2.88z"/>
                                </svg>
                            </a>
                        </div>
                    </div>

                    {/* Column 2: Navigate - Centered on mobile */}
                    <div className="text-center md:text-left">
                        <h4 className="font-semibold text-white mb-4">Navigate</h4>
                        <ul className="space-y-2 text-sm">
                            <li><a href="#about" className="hover:text-cyan-400 transition-colors">About Us</a></li>
                            <li><a href="#services" className="hover:text-cyan-400 transition-colors">Services</a></li>
                            <li><a href="#work" className="hover:text-cyan-400 transition-colors">Our Work</a></li>
                            <li><a href="#contact" className="hover:text-cyan-400 transition-colors">Contact</a></li>
                            <li><Link to="/blog" className="hover:text-cyan-400 transition-colors">Blog</Link></li>
                            <li><Link to="/privacy-policy" className="hover:text-cyan-400 transition-colors">Privacy Policy</Link></li>
                        </ul>
                    </div>

                    {/* Column 3: Get in Touch - Centered on mobile */}
                    <div className="text-center md:text-left">
                        <h4 className="font-semibold text-white mb-4">Get in Touch</h4>
                        <ul className="space-y-2 text-sm">
                            <li className="flex items-center gap-2 justify-center md:justify-start"><Mail size={16} /><a href="mailto:info@smartsolutionslk.com" className="hover:text-cyan-400 transition-colors">info@smartsolutionslk.com</a></li>
                            <li className="flex items-center gap-2 justify-center md:justify-start"><Phone size={16} /><a href="tel:+94742111150" className="hover:text-cyan-400 transition-colors">+94 74 211 1150</a></li>
                            <li className="flex items-center gap-2 justify-center md:justify-start"><Phone size={16} /><a href="tel:+94701111150" className="hover:text-cyan-400 transition-colors">+94 70 111 1150</a></li>
                        </ul>
                    </div>

                    {/* Column 4: Stay Connected - Centered on mobile */}
                    <div className="text-center md:text-left">
                        <h4 className="font-semibold text-white mb-4">Stay Connected</h4>
                        <p className="text-sm mb-3">Get the latest insights and updates from our team.</p>
                        <form onSubmit={handleSubscription} className="flex max-w-sm mx-auto md:mx-0">
                            <input 
                                type="email" 
                                placeholder="Your Email" 
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                required
                                className="w-full p-2 bg-gray-800 border border-gray-700 rounded-l-md focus:outline-none focus:ring-2 focus:ring-cyan-400 text-sm" />
                            <button type="submit" className="bg-cyan-500 text-black p-2 rounded-r-md hover:bg-cyan-400 transition-colors">
                                <ArrowRight size={20}/>
                            </button>
                        </form>
                        {subscribeStatus && <p className="text-sm mt-2 text-cyan-400">{subscribeStatus}</p>}
                    </div>
                </div>

                <div className="border-t border-gray-800 pt-8 text-center text-sm">
                    <p>&copy; {new Date().getFullYear()} Smart Solutions Pvt Ltd. All Rights Reserved.</p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;